<p-table [columns]="tableCols" [value]="masterLists" selectionMode="single" [(selection)]="selectedMasterList"
  (onRowSelect)="onRowSelect($event)" [loading]="loading">
  <ng-template pTemplate="caption">
    {{title}}
  </ng-template>

  <ng-template pTemplate="header" let-columns>
    <tr>
      <th id="{{col.field+'Column'}}" *ngFor="let col of columns"
        [ngStyle]="{'width': col.width ,'display': col.display}"
        [pSortableColumn]="col.field=='lab' ? col.sort:col.field">
        {{col.header}}
        <p-sortIcon [field]="col.field=='lab' ? col.sort:col.field"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <ng-container *ngFor="let col of columns">
        <td class="text-break" [ngStyle]="{'display': col.display}" *ngIf="col.field == 'analysisName'">
          {{rowData[col.field]}}
        </td>
        <td class="text-break" [ngStyle]="{'display': col.display}" *ngIf="col.field == 'pipelineName'">
          {{rowData[col.field]}}
        </td>

        <td class="text-break" [ngStyle]="{'display': col.display}" *ngIf="col.field == 'versionOfAnalysis' ">
          {{rowData[col.field]}}
        </td>

        <td class="text-break" [ngStyle]="{'display': col.display}" *ngIf="col.field == 'sequencer' ">
          {{rowData[col.field]}}
        </td>
        <td *ngIf="col.field == 'product'">
          <p-checkbox id="product" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>

        <td class="text-break" [ngStyle]="{'display': col.display}" *ngIf="col.field == 'productId' ">
          {{rowData[col.field]}}
        </td>

        <td *ngIf="col.field == 'mismatch'">
          <p-checkbox id="mismatch" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>
        <td *ngIf="col.field == 'limsUpload'">
          <p-checkbox id="limsUpload" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>
        <td *ngIf="col.field == 'autoAnalysis'">
          <p-checkbox id="autoAnalysis" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>

        <td *ngIf="col.field == 'reanalysis'">
          <p-checkbox id="reanalysis" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>

        <td *ngIf="col.field == 'indexAnalysis'">
          <p-checkbox id="indexanalysis" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>

        <td *ngIf="col.field == 'ignoreMissingFiles'">
          <p-checkbox id="ignoreMissingFiles" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>

        <td *ngIf="col.field == 'lab' ">
          {{rowData[col.field]!= null? rowData[col.field].name :''}}
        </td>

        <td *ngIf="col.field == 'active'">
          <p-checkbox id="active" disabled [(ngModel)]="rowData[col.field]" binary="true"></p-checkbox>
        </td>
      </ng-container>
    </tr>
  </ng-template>
  <ng-template pTemplate="summary" let-rowData>
    <div class="textAlignment">
      <button type="button" pButton icon="pi pi-plus" (click)="showDialogToAddMasterList()" style="height: 35px;" label="Add"></button>
    </div>
  </ng-template>
</p-table>

<p-dialog header="{{title}} Details" [(visible)]="displayMasterListDialog" [focusOnShow]="false" showEffect="fade" [modal]="true" [style.width]="'600px'" position="top" [contentStyle]="{'overflow':'auto'}" baseZIndex="10">
  <div *ngIf="masterList">
    <div *ngFor="let col of tableCols">
      <div class="form-group m-2">
        <div *ngIf="col.field != 'constraint' && col.field != 'product' && col.field != 'productId' ">
          <label>{{col.header}}</label>
        </div>
        <div *ngIf="col.field == 'analysisName'">
          <input pInputText class="form-control" [(ngModel)]="masterList[col.field]"
            (change)="masterList[col.field]=masterList[col.field].trim()">
        </div>
        <div *ngIf="col.field == 'pipelineName'">
          <input pInputText class="form-control" [(ngModel)]="masterList[col.field]"
            (change)="masterList[col.field]=masterList[col.field].trim()">
        </div>

        <div *ngIf="col.field == 'versionOfAnalysis'">
          <input pInputText class="form-control" [(ngModel)]="masterList[col.field]"
            (change)="masterList[col.field]=masterList[col.field].trim()">
        </div>


        <div *ngIf="col.field == 'sequencer'">
          <p-dropdown [options]="sequencerOptions" [filter]="true" placeholder="Select a Sequencer" optionLabel="name"
            [showClear]="true" [(ngModel)]="selectedSequencer"></p-dropdown>
        </div>

        <div *ngIf="col.field == 'constraint'">
          Constraint
          <table aria-hidden="true" style="width: 100%; padding-left: 9%; border:1px solid black">
            <div style="margin-top:2% ;padding-left: 2%"><label>Product</label></div>
            
            <div style="padding-left: 2%">
              <p-checkbox [(ngModel)]="masterList['product']" binary="true" (onChange)="checkValue($event.value)"></p-checkbox>
            </div>
            <div>
              <p></p>
            </div>

            <div style="padding-left: 2%"> <label>Product Id</label> </div>
            <div class="w-100 p-2"> <input pInputText class="form-control" [disabled]="isProductIdDisabled()"
                [(ngModel)]="masterList['productId']" (change)="masterList['productId']=masterList['productId'].trim()">
            </div>
          </table>
        </div>


        <div *ngIf="col.field == 'mismatch'">
          <p-checkbox [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
        </div>

        <div *ngIf="col.field == 'limsUpload'">
          <p-checkbox [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
        </div>


        <div *ngIf="col.field == 'autoAnalysis'">
          <p-checkbox [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
        </div>


        <div *ngIf="col.field == 'reanalysis'">
          <p-checkbox [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
        </div>

        <div *ngIf="col.field == 'indexAnalysis'">
          <p-checkbox [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
        </div>
        <div *ngIf="col.field == 'ignoreMissingFiles'">
          <p-checkbox [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
        </div>


        <div *ngIf="col.field == 'active'">
          <p-checkbox [(ngModel)]="masterList[col.field]" binary="true"></p-checkbox>
        </div>
      </div>
      <div *ngIf="col.field == 'lab'">
        <p-dropdown [options]="labOptions" [(ngModel)]="selectedLab" [filter]="true" placeholder="Select a Lab"
          optionLabel="name" [showClear]="true"></p-dropdown>
      </div>

    </div>
  </div>
  <div class="ui-dialog-buttonpane ui-helper-clearfix">
    <button type="button" pButton icon="pi pi-check" [disabled]="isSaveDisabled()" (click)="saveMasterListData()"
      label="Save" class="saveButton"></button>
  </div>
</p-dialog>